import * as types from './mutations-types';
import * as util from 'assets/js/util';

// let action = {
//   handler: () => {},
//   updateUserInfo ({commit, state}, data) {
//     commit(types.RECORD_USERINFO, data);
//     commit(types.UPDATA_USERGUID, data.guid);
//   }
// };
//
// export default action;

export let updateUserInfo = function ({ commit, sFtate }, data) {
  commit(types.RECORD_USERINFO, data.result);
  commit(types.UPDATE_AUTHORTOKEN, data.idfm);
};
export let signIn = function ({ commit, state }, data) {
  commit(types.RECORD_USERINFO, data.result);
  commit(types.UPDATE_AUTHORTOKEN, data.idfm);
};
export let signOut = function ({ commit, state }) {
  commit(types.REMOVE_USEINFO);
  commit(types.REMOVE_AUTHORTOKEN);
};

export let updateOrderAllInfo = function ({ commit, sFtate }, { time, info, state }) {
  commit(types.UPDATE_ORDERVTIME, time);
  commit(types.UPDATE_ORDERINFO, info);
  commit(types.UPDATE_ORDERINQUIRESTATE, state);
};

export let removeOrderState = function ({ commit, state }) {
  commit(types.REMOVE_ORDERINFO);
  commit(types.REMOVE_ORDERINQUIRESTATE);
  commit(types.REMOVE_ORDERVTIME);
};
export let recordHistory = function ({ commit, state }, data) {
  commit(types.UPDATE_FIRSTENTER, data.isfirst);
  commit(types.RECORD_ROUTERHISTORY, data.path);
};
export let recordBeforeLoginPage = function ({ commit, state }, data) {
  setTimeout(() => {
    commit(types.UPDATE_BEFORELOGINPAGE, data);
  }, 500);
  // commit(types.UPDATE_BEFORELOGINPAGE, data);
};



// WEBPACK FOOTER //
// ./src/store/actions.js